export const whatIsCabelEdges = [
  {
    id: "90.123.29.119-126.134.35.41",
    source: "126.134.35.41",
    target: "90.123.29.119",
    type: "straight",
  },
  {
    id: "126.134.35.41-159.146.191.67",
    source: "126.134.35.41",
    target: "159.146.191.67",
    type: "straight",
  },

  {
    id: "224.109.172.5-71dd::ad48:7474:3412",
    source: "224.109.172.5",
    target: "71dd::ad48:7474:3412",
    type: "straight",
  },
  {
    id: "17.246.37.189-224.109.172.5",
    source: "17.246.37.189",
    target: "224.109.172.5",
    type: "straight",
  },
];
